import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-24fbd147"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "animate wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "animate modal"
}
const _hoisted_5 = { class: "modal-inner" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Antes de responder...", -1))
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", { style: {"font-size":"14px"} }, "Se amable y constructivo."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Muchos compañeros están empezando y tu experiencia seguro que les será de gran ayuda. ¡Mantengamos un buen ambiente!")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "new-question" }, "Escribir Respuesta", -1))
const _hoisted_10 = { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_11 = { class: "new-question" }
const _hoisted_12 = { class: "secondary" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { class: "question" }
const _hoisted_16 = { class: "user" }
const _hoisted_17 = { class: "profile" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "reputation" }
const _hoisted_21 = { class: "question-content" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 1,
  class: "spacer"
}
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = {
  key: 3,
  class: "spacer"
}
const _hoisted_28 = { key: 4 }
const _hoisted_29 = {
  key: 5,
  class: "repository"
}
const _hoisted_30 = ["href"]
const _hoisted_31 = {
  key: 0,
  class: "animate wrapper"
}
const _hoisted_32 = { class: "question" }
const _hoisted_33 = { class: "user" }
const _hoisted_34 = { class: "profile" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "reputation" }
const _hoisted_38 = { class: "" }
const _hoisted_39 = {
  class: "likes",
  style: {"overflow":"hidden"}
}
const _hoisted_40 = { class: "question-content" }
const _hoisted_41 = { class: "correct-answer" }
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_44 = { class: "question" }
const _hoisted_45 = { class: "user" }
const _hoisted_46 = { class: "profile" }
const _hoisted_47 = ["src"]
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "reputation" }
const _hoisted_50 = { class: "secondary" }
const _hoisted_51 = {
  class: "likes",
  style: {"overflow":"hidden"}
}
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { class: "question-content" }
const _hoisted_54 = {
  key: 0,
  class: "most-voted"
}
const _hoisted_55 = ["innerHTML"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import { ref, onMounted, Ref } from 'vue'
import ForumService from '@/services/ForumService';
import { useRoute } from 'vue-router';
import useWindowWidth from '@/composables/useWindowWidth';
import { useAuth } from '@/store/useAuth';
import { useToast } from '@/store/useToast'
import { Toast } from '@/interfaces/ToastInterface';
import ReputationCardUsers from '@/components/widgets/ReputationCardUsers.vue';
import main from '@/data/main.js';
import {QuestionI, UserI} from '@/interfaces/ForumWriteInterface'


export default /*#__PURE__*/_defineComponent({
  __name: 'ForumDetailGeneralView',
  setup(__props) {

const toast = useToast()
const loading = ref(true)
const forumService = new ForumService()
const question = ref<QuestionI | null>(null)
const route = useRoute()
const topic_id = route.params.topic_id
const topic_name = route.params.topic_name
const showAdvice = ref(false)
const {windowWidth} = useWindowWidth()
const store = useAuth()
const myUser = ref<UserI | null>(null);
const goldenAnswer:Ref<any> = ref({})

onMounted(async () => {
    loading.value = true
    if(store.token) {
        const rawResponse = await fetch(`${main.BASE_ENDPOINT}/my-user`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${store.token}`
            }
        })
        myUser.value = await rawResponse.json()
    }
  
    await updateInfo()
    loading.value = false
})

const updateInfo = async () => {
    question.value = await forumService.GetQuestionWithAnswers(route.params.question_id)
    goldenAnswer.value = question.value?.answers.find(item => item.is_correct == '1');
    question.value?.answers.sort((a, b) => likeDislikeNumber(b.likes) - likeDislikeNumber(a.likes));
}

const markAsSolution = async (answer_id:string) => {
    if(!store.token) { 
        toast.showToast("Debes registrarte o acceder para realizar esta acción.", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return 
    }
    const answer = await forumService.MarkAsCorrect(store.token, answer_id)

    if(answer.success) {
        toast.showToast(answer.message, Toast.SUCCESS)
        setTimeout(function () { toast.hideToast() }, 4000);
        await updateInfo()
    } else {
        toast.showToast(answer.message, Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
    }
}

const likeDislikeNumber = (_likes:any):number => {
    let likes = 0;
    _likes.forEach((element:any) => {
        if(element.pivot.liked == '1') {
            likes++;
        } else {
            likes--;
        }
    });
    return likes;
}

const likeDislike = (_likes:any):string => {
    let likes = 0;
    _likes.forEach((element:any)  => {
        if(element.pivot.liked == '1') {
            likes++;
        } else {
            likes--;
        }
    });
    return likes.toLocaleString();
}

const doLike = async (id:string) => {
    if(!store.token) {
        toast.showToast("Necesitas registrarte / loguearte para dar like.", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return;
    }
    const response = await forumService.DoLike(store.token, id)
    if(response != true) {
        toast.showToast("Uups... Algo salió mal", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return;
    }

    toast.showToast("Has dado me gusta a la respuesta", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000);

    await updateInfo()
}

const doDislike = async (id:string) => {
    if(!store.token) {
        toast.showToast("Necesitas registrarte / loguearte para dar dislike.", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return;
    }
    const response = await forumService.DoDislike(store.token, id)
    if(response != true) {
        toast.showToast("Uups... Algo salió mal", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return;
    }

    toast.showToast("Has dado NO me gusta a la respuesta", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000);

    await updateInfo()
}

const undoLike = async (id:string) => {
    if(!store.token) {
        toast.showToast("Necesitas registrarte / loguearte para hacer esta acción.", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return;
    }
    const response = await forumService.UndoLike(store.token, id)
    if(response != true) {
        toast.showToast("Uups... Algo salió mal", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return;
    }

    toast.showToast("Ha dejado de gustarte la respuesta", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000);

    await updateInfo()
}

const undoDislike = async (id:string | undefined) => {
    if(!store.token) {
        toast.showToast("Necesitas registrarte / loguearte para hacer esta acción.", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return;
    }
    const response = await forumService.UndoDislike(store.token, id)
    if(response != true) {
        toast.showToast("Uups... Algo salió mal", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return;
    }

    toast.showToast("Ha dejado de NO gustarte la respuesta", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000);

    await updateInfo()
}

const checkIfIsLiked = (likes:any):boolean => {
    if(!store.token) {
        return false
    }
    return likes.some((item:any )=> item.id == myUser.value?.id && item.pivot.liked == '1' );
}

const checkIfIsDisliked = (likes:any):boolean => {
    if(!store.token) {
        return false
    }
    return likes.some((item:any) => item.id == myUser.value?.id && item.pivot.liked == '0' );
}


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (showAdvice.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", {
                        style: {"float":"right","cursor":"pointer"},
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (showAdvice.value = false))
                      }, [
                        _createVNode(_component_v_icon, {
                          name: "ri-close-circle-fill",
                          fill: "lightcoral"
                        })
                      ]),
                      _hoisted_6,
                      (_unref(windowWidth) >= 1000)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _unref(main).RESPONSE_QUESTION_COURSE,
                            style: {"width":"100%"}
                          }, null, 8, _hoisted_7))
                        : _createCommentVNode("", true),
                      _hoisted_8,
                      _createVNode(_component_RouterLink, {
                        to: {name: 'my-answer', params: {question_id:question.value?.id}},
                        style: {"text-decoration":"none"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_RouterLink, {
                  to: {name: 'forum-general-list', params: {topic_id: _unref(topic_id), topic_name: _unref(topic_name)}},
                  style: {"text-decoration":"none"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", _hoisted_11, [
                      _createVNode(_component_v_icon, {
                        name: "bi-arrow-left-circle-fill",
                        style: {"margin-right":"10px"}
                      }),
                      _createTextVNode("Volver Atrás")
                    ])
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createElementVNode("h3", _hoisted_12, _toDisplayString(_unref(topic_name)), 1),
                (question.value?.is_solved == '0')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "new-question",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (showAdvice.value = true))
                    }, [
                      _createTextVNode("Escribir Respuesta "),
                      _createVNode(_component_v_icon, {
                        name: "io-send",
                        style: {"margin-left":"10px"}
                      })
                    ]))
                  : (question.value?.is_inactive == '0')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                        _createVNode(_component_v_icon, {
                          name: "bi-check-circle-fill",
                          fill: "#BECE49"
                        }),
                        _createTextVNode("Esta pregunta ha sido marcada como solucionada por su autor")
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_14, [
                        _createVNode(_component_v_icon, {
                          name: "bi-check-circle-fill",
                          fill: "#BECE49"
                        }),
                        _createTextVNode("Esta pregunta ha sido marcada como solucionada por inactividad.")
                      ]))
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    (question.value?.user.profile_picture_uri)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: question.value?.user.profile_picture_uri
                        }, null, 8, _hoisted_18))
                      : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(question.value?.user.name.substring(0, 2)), 1))
                  ]),
                  _createVNode(_component_RouterLink, {
                    to: { name: 'social-profile', params: { id: question.value?.user.id } },
                    style: {"text-decoration":"none"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(question.value?.user.name), 1),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(ReputationCardUsers, {
                          user_id: question.value?.user.id
                        }, null, 8, ["user_id"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("h1", null, _toDisplayString(question.value?.name), 1),
                  _createElementVNode("div", {
                    innerHTML: question.value?.description,
                    class: "description"
                  }, null, 8, _hoisted_22),
                  _hoisted_23,
                  (question.value?.try)
                    ? (_openBlock(), _createElementBlock("h3", _hoisted_24, "Para solucionarlo, " + _toDisplayString(question.value?.user.name) + " ha intentado...", 1))
                    : _createCommentVNode("", true),
                  (question.value?.try)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25))
                    : _createCommentVNode("", true),
                  (question.value?.try)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        innerHTML: question.value.try,
                        class: "description"
                      }, null, 8, _hoisted_26))
                    : _createCommentVNode("", true),
                  (question.value?.repository)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27))
                    : _createCommentVNode("", true),
                  (question.value?.repository)
                    ? (_openBlock(), _createElementBlock("h3", _hoisted_28, _toDisplayString(question.value.user.name) + " nos deja el siguiente repositorio para encontrar la solución", 1))
                    : _createCommentVNode("", true),
                  (question.value?.repository)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("a", {
                          href: question.value?.repository,
                          target: "_blank"
                        }, _toDisplayString(question.value?.repository), 9, _hoisted_30)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (question.value?.is_solved == '1' && question.value.is_inactive == '0')
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        (goldenAnswer.value?.user.profile_picture_uri)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: goldenAnswer.value.user.profile_picture_uri
                            }, null, 8, _hoisted_35))
                          : (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(goldenAnswer.value?.user.name.substring(0, 2)), 1))
                      ]),
                      _createVNode(_component_RouterLink, {
                        to: { name: 'social-profile', params: { id: goldenAnswer.value?.user.id } },
                        style: {"text-decoration":"none"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(goldenAnswer.value?.user.name), 1),
                          _createElementVNode("div", _hoisted_37, [
                            _createVNode(ReputationCardUsers, {
                              user_id: goldenAnswer.value?.user.id
                            }, null, 8, ["user_id"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _createElementVNode("h3", _hoisted_38, _toDisplayString(likeDislike(goldenAnswer.value?.likes)), 1),
                      _createElementVNode("div", _hoisted_39, [
                        (checkIfIsLiked(goldenAnswer.value?.likes))
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 0,
                              name: "bi-hand-thumbs-up-fill",
                              scale: "2",
                              animation: "wrench",
                              hover: "true",
                              fill: _unref(main).SECONDARY_COLOR,
                              style: {"cursor":"pointer"},
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (undoLike(goldenAnswer.value?.id)))
                            }, null, 8, ["fill"]))
                          : (_openBlock(), _createBlock(_component_v_icon, {
                              key: 1,
                              name: "bi-hand-thumbs-up-fill",
                              scale: "2",
                              animation: "wrench",
                              hover: "true",
                              style: {"cursor":"pointer"},
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (doLike(goldenAnswer.value.id)))
                            })),
                        (checkIfIsDisliked(goldenAnswer.value?.likes))
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 2,
                              name: "bi-hand-thumbs-down-fill",
                              scale: "2",
                              animation: "wrench",
                              hover: "true",
                              fill: _unref(main).SECONDARY_COLOR,
                              style: {"cursor":"pointer"},
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (undoDislike(goldenAnswer.value?.id)))
                            }, null, 8, ["fill"]))
                          : (_openBlock(), _createBlock(_component_v_icon, {
                              key: 3,
                              name: "bi-hand-thumbs-down-fill",
                              scale: "2",
                              animation: "wrench",
                              hover: "true",
                              style: {"cursor":"pointer"},
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (doDislike(goldenAnswer.value?.id)))
                            }))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createVNode(_component_v_icon, { name: "bi-award-fill" }),
                        _createTextVNode("Esta es la respuesta correcta según el autor de la pregunta")
                      ]),
                      _createElementVNode("div", {
                        innerHTML: goldenAnswer.value?.answer,
                        class: "description"
                      }, null, 8, _hoisted_42),
                      _hoisted_43
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.value?.answers, (answer, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "animate wrapper",
                key: answer.id
              }, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      (answer.user.profile_picture_uri)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: answer.user.profile_picture_uri
                          }, null, 8, _hoisted_47))
                        : (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(answer.user.name.substring(0, 2)), 1))
                    ]),
                    _createVNode(_component_RouterLink, {
                      to: { name: 'social-profile', params: { id: answer.user.id } },
                      style: {"text-decoration":"none"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", null, _toDisplayString(answer.user.name), 1),
                        _createElementVNode("div", _hoisted_49, [
                          _createVNode(ReputationCardUsers, {
                            user_id: answer.user.id
                          }, null, 8, ["user_id"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _createElementVNode("h3", _hoisted_50, _toDisplayString(likeDislike(answer.likes)), 1),
                    _createElementVNode("div", _hoisted_51, [
                      (checkIfIsLiked(answer.likes))
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            name: "bi-hand-thumbs-up-fill",
                            scale: "2",
                            animation: "wrench",
                            hover: "true",
                            fill: _unref(main).SECONDARY_COLOR,
                            style: {"cursor":"pointer"},
                            onClick: ($event: any) => (undoLike(answer.id))
                          }, null, 8, ["fill", "onClick"]))
                        : (_openBlock(), _createBlock(_component_v_icon, {
                            key: 1,
                            name: "bi-hand-thumbs-up-fill",
                            scale: "2",
                            animation: "wrench",
                            hover: "true",
                            style: {"cursor":"pointer"},
                            onClick: ($event: any) => (doLike(answer.id))
                          }, null, 8, ["onClick"])),
                      (checkIfIsDisliked(answer.likes))
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 2,
                            name: "bi-hand-thumbs-down-fill",
                            scale: "2",
                            animation: "wrench",
                            hover: "true",
                            fill: _unref(main).SECONDARY_COLOR,
                            style: {"cursor":"pointer"},
                            onClick: ($event: any) => (undoDislike(answer.id))
                          }, null, 8, ["fill", "onClick"]))
                        : (_openBlock(), _createBlock(_component_v_icon, {
                            key: 3,
                            name: "bi-hand-thumbs-down-fill",
                            scale: "2",
                            animation: "wrench",
                            hover: "true",
                            style: {"cursor":"pointer"},
                            onClick: ($event: any) => (doDislike(answer.id))
                          }, null, 8, ["onClick"]))
                    ]),
                    ((question.value?.is_solved == '0') && (question.value.user_id == myUser.value?.id))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "mark-as-solution",
                          onClick: ($event: any) => (markAsSolution(answer.id))
                        }, [
                          _createVNode(_component_v_icon, { name: "bi-award-fill" }),
                          _createTextVNode(" Marcar como solución ")
                        ], 8, _hoisted_52))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    (index == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          _createVNode(_component_v_icon, { name: "gi-three-friends" }),
                          _createTextVNode("Respuesta mejor valorada por los compañeros")
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      innerHTML: answer.answer,
                      class: "description"
                    }, null, 8, _hoisted_55),
                    _hoisted_56
                  ])
                ])
              ]))
            }), 128))
          ]))
    ]),
    _: 1
  }))
}
}

})